import { DataCard } from '@/reports/shared/DataCard/DataCard';
import {
  AutomobileAuction,
  AutomobileReportedDamage,
} from '@/reports/types/vehicles';
import { Text } from '@/theme/index';
import { formatDateFromReport } from '@/utils/formatDateFromReport/formatDateFromReport';
import { capitalizeString } from '@/utils/index';

interface VehicleDamage {
  damage: AutomobileAuction | AutomobileReportedDamage;
}

export function VehicleDamageCard({ damage }: VehicleDamage) {
  const description = capitalizeString(
    (damage as AutomobileReportedDamage).description ||
      (damage as AutomobileAuction).vehicle_condition_details
        ?.damage_description ||
      ''
  );
  const date = formatDateFromReport(damage.date?.full || '');
  return (
    <DataCard testId="vehicle-damage-card">
      <Text fontSize="1.5rem" data-testid="vehicle-damage-card-title">
        Damage reported on <strong>{date}</strong>
      </Text>
      <Text fontSize="0.75rem">
        <strong>Source:</strong> Copart
      </Text>
      <Text fontSize="1.125rem">{description}</Text>
    </DataCard>
  );
}
